import { useMutation } from "@tanstack/react-query";
import { t } from "ttag";

import { sendCheckoutLink } from "@/features/onboarding/api";
import { errorToast, useToastStore } from "@/shared/ui";

export const useSendCheckoutLink = () =>
  useMutation({
    mutationFn: sendCheckoutLink,
    onSuccess: () =>
      void useToastStore.getState().pushToast({
        type: "success",
        title: t`Email sent`,
        message: t`The patient will receive an email to complete their order.`,
      }),
    onError: errorToast,
  });
